import React from 'react';
import { CheckCircle2, Award, Users, Target } from 'lucide-react';

const ABOUT_IMAGE = "https://images.pexels.com/photos/32588555/pexels-photo-32588555.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const About = () => {
  const highlights = [
    {
      icon: Award,
      title: '10 Anos de Experiência',
      description: 'Atuação consolidada no mercado de climatização comercial e industrial.',
    },
    {
      icon: Target,
      title: 'Foco em Resultados',
      description: 'Projetos desenvolvidos para atender as necessidades específicas de cada cliente.',
    },
    {
      icon: Users,
      title: 'Equipe Técnica',
      description: 'Profissionais qualificados e capacitados para oferecer o melhor atendimento.',
    },
  ];

  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-20 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Column */}
          <div className="relative" data-testid="about-image-container">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-slate-200/50">
              <img
                src={ABOUT_IMAGE}
                alt="Técnico realizando manutenção em sistema de climatização"
                className="w-full h-[400px] lg:h-[500px] object-cover"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats Card */}
            <div
              className="absolute -bottom-6 -right-6 lg:-right-12 bg-white rounded-2xl shadow-xl p-6 border border-slate-100"
              data-testid="about-stats-card"
            >
              <div className="text-center">
                <span className="font-outfit text-5xl font-bold stat-number">10+</span>
                <p className="font-manrope text-sm text-slate-600 mt-1">Anos de<br />experiência</p>
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div data-testid="about-content">
            {/* Overline */}
            <span className="font-manrope text-sm font-bold tracking-[0.2em] uppercase text-sky-600">
              Sobre a Empresa
            </span>

            {/* Heading */}
            <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 mt-4 mb-6">
              Compromisso com a excelência em climatização
            </h2>

            {/* Divider */}
            <div className="section-divider mb-6"></div>

            {/* Description */}
            <p className="font-manrope text-base sm:text-lg text-slate-600 leading-relaxed mb-8">
              A Tokefrio Climatização atua há mais de 10 anos no mercado de climatização 
              comercial e industrial em Cuiabá e região. Nossa empresa oferece soluções 
              completas que incluem projetos personalizados, execução de obras e serviços 
              de manutenção preventiva e corretiva.
            </p>

            <p className="font-manrope text-base sm:text-lg text-slate-600 leading-relaxed mb-8">
              Trabalhamos com foco em eficiência energética, conforto térmico e atendimento 
              técnico especializado, garantindo que cada projeto seja desenvolvido de acordo 
              com as necessidades específicas do cliente.
            </p>

            {/* Highlights */}
            <div className="space-y-4" data-testid="about-highlights">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 bg-slate-50 rounded-xl hover:bg-sky-50 transition-colors duration-300"
                  data-testid={`about-highlight-${index}`}
                >
                  <div className="flex-shrink-0 w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center">
                    <item.icon className="w-5 h-5 text-sky-600" />
                  </div>
                  <div>
                    <h3 className="font-outfit text-lg font-semibold text-slate-800">
                      {item.title}
                    </h3>
                    <p className="font-manrope text-sm text-slate-600 mt-1">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
